import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { JwtService } from '@gray/domain/http/jwt.service';

@Injectable()
export class CoachJwtInterceptor implements HttpInterceptor {
  constructor(
    private jwtService: JwtService,
  ) {
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const headersConfig: { [header: string]: string } = {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    };

    const token = this.jwtService.getToken();
    if (token && (token.length > 3) && (!req.url.includes('amazonaws'))) {
      headersConfig['Authorization'] = `Bearer ${token}`;
    }

    // Let the browser set the boundary itself when a body is sent as form data.
    if (req.body instanceof FormData) {
      delete headersConfig['Content-Type'];
    }

    return next.handle(req.clone({setHeaders: headersConfig}));
  }
}
